<template>
    <AuthLayout>
        <div
            class="relative flex min-h-screen w-full max-w-(--breakpoint-2xl) flex-col items-center sm:justify-start sm:pt-20"
        >
            <div
                class="mt-8 flex w-full flex-col items-center overflow-hidden bg-white p-6 shadow-xl sm:mt-14 sm:max-w-md sm:rounded-[8px]"
            >
                <div class="-mt-1 h-[240px] w-[240px]">
                    <img
                        src="https://d1vyenbk43iobe.cloudfront.net/application/images/auth/forgotten-email@2x.png"
                        class="ml-[10px] mt-[10px] h-full w-full"
                        alt="Topol Illustration"
                    />
                </div>

                <div class="mt-[14px] text-xl font-bold text-gray-800">
                    Check your inbox!
                </div>

                <div
                    class="mb-[31px] mt-3 max-w-sm text-center text-sm text-gray-500"
                >
                    {{ message }}
                </div>
            </div>

            <!-- First Promoter -->
            <component
                :is="'script'"
                src="https://cdn.firstpromoter.com/fpr.js"
                async
            ></component>
        </div>
    </AuthLayout>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { useGtm } from '@/composables/useGtm';

withDefaults(defineProps<{ message?: string }>(), {
    message: "We've sent you instructions how to reset your password.",
});

const page = usePage();
const { pushEvent } = useGtm();

onMounted(() => {
    const flash = (page.props as any).flash;
    const registeredEmail = flash?.data?.registered_email;

    if (!registeredEmail) {
        return;
    }

    pushEvent('topol_create_account');

    // First Promoter
    // @ts-ignore
    (function (w) {
        w.fpr =
            w.fpr ||
            function () {
                w.fpr.q = w.fpr.q || [];
                w.fpr.q[arguments[0] == 'set' ? 'unshift' : 'push'](arguments);
            };
    })(window);
    // @ts-ignore
    fpr('init', { cid: 'l3vfa0xc' });
    // @ts-ignore
    fpr('referral', { email: registeredEmail });

    // Reditus
    // @ts-ignore
    (function (w) {
        w.gr =
            w.gr ||
            function () {
                w.gr.ce = 120;
                w.gr.q = w.gr.q || [];
                w.gr.q.push(arguments);
            };
    })(window);

    const reditusScript = document.createElement('script');
    reditusScript.src = 'https://script.getreditus.com/v2.js';
    reditusScript.async = true;
    document.head.appendChild(reditusScript);

    // @ts-ignore
    gr('initCustomer', '1d0b5209-b652-4690-b8e1-9bc73a627c32');
    // @ts-ignore
    gr('track', 'pageview');
    // @ts-ignore
    gr('track', 'conversion', { email: registeredEmail });
});
</script>
